import { appApiUrl } from '../../../utils/appApiOrigin';

function isHttpUrl(value) {
  try {
    const parsed = new URL(String(value || '').trim());
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
}

/** Same-origin or blob/data URLs — safe to fetch directly from the browser. */
export function isSameOriginFetchUrl(rawUrl) {
  const trimmed = String(rawUrl || '').trim();
  if (!trimmed || trimmed.startsWith('blob:') || trimmed.startsWith('data:')) return true;
  if (typeof window === 'undefined') return false;
  if (!isHttpUrl(trimmed)) return true;
  try {
    return new URL(trimmed).origin === window.location.origin;
  } catch {
    return false;
  }
}

/**
 * Offline download fetch URL: external http(s) streams go through SSRF-safe API proxy.
 */
export function resolveAudioOfflineFetchUrl(src) {
  const trimmed = String(src || '').trim();
  if (!trimmed || isSameOriginFetchUrl(trimmed)) return trimmed;
  if (!isHttpUrl(trimmed)) return trimmed;
  return appApiUrl(`/api/public/audio-offline-fetch?url=${encodeURIComponent(trimmed)}`);
}
